export var loadedProducts: [] = [];

export function setLoadedProducts (p: []) {
  if (p != null && p.length != 0)
    loadedProducts = p;
}
